import {
    CountryWithPostalCodeAsAddressLookup,
    REVERSE_NAME_ORDER_COUNTRY_CODES,
} from "@lib/constants/addresses";
import type { TCountryCode } from "countries-list";
import { fullNameParser } from "@lib/validators/regex/general";

export const isCountryWithReverseNameOrder = (countryCode: TCountryCode) => {
    return REVERSE_NAME_ORDER_COUNTRY_CODES.includes(countryCode);
};

// We are saving a full name in my-addresses and receiving first and last name for checkout.
export const separateFullName = (fullName: string, countryCode: TCountryCode) => {
    const nameParts = fullName?.trim()?.match(fullNameParser);

    if (!nameParts || nameParts.length < 2) {
        return [fullName, fullName];
    }

    const isReversed = isCountryWithReverseNameOrder(countryCode);

    const firstName = isReversed ? nameParts.slice(1).join(" ") : nameParts.slice(0, -1).join(" ");
    const lastName = isReversed ? nameParts[0] : nameParts[nameParts.length - 1];

    return [firstName, lastName];
};

export const fieldKeyForAdrressLookup = (countryCode: string) => {
    return CountryWithPostalCodeAsAddressLookup.includes(countryCode) ? "postalCode" : "streetName";
};

export const usesPostalCodeLookup = (country: string): boolean => {
    return CountryWithPostalCodeAsAddressLookup.includes(country);
};

// Some engines reject the `u` flag with \p{N}; fall back to Latin, Arabic-Indic
// and Extended Arabic-Indic digits.
const FALLBACK_DIGITS = /[0-9٠-٩۰-۹]/;

const getDigitMatcher = (): RegExp => {
    try {
        return new RegExp("\\p{N}", "u");
    } catch {
        return FALLBACK_DIGITS;
    }
};

export const hasHouseNumber = (streetName?: string | null): boolean => {
    const value = streetName?.trim();
    if (!value) {
        return false;
    }
    return getDigitMatcher().test(value);
};
